import {
  DeleteOutlined, DownloadOutlined, InboxOutlined,
} from '@ant-design/icons';
import {
  Button,
  Card, Col, Modal, notification, Row,
} from 'antd';
import PropTypes from 'prop-types';
import React, {
  useEffect,
  useState,
} from 'react';
import Dragger from 'antd/lib/upload/Dragger';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { updateCoexecutorStep, uploadFile } from '../../../../utils/http';


export const Act = ({ stepId, stepData, onRefetchData }) => {
  const [showUploadModal, setShowUploadActModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [actFile, setActFile] = useState(stepData.actFile || null);

  const handleRemoveFile = () => {
    setActFile(null);
  };

  const handleUpdateActFile = async (json) => {
    try {
      const resp = await updateCoexecutorStep({ id: stepId, stepJSON: JSON.stringify(json) });

      if (resp.status !== 'OK') {
        notification.error({ message: 'Произошла ошибка. Попробуйте еще раз' });
        setLoading(false);
        return;
      }

      setShowUploadActModal(false);
      // onRefetchData();
      notification.success({ message: 'Сохранено' });
    } catch (e) {
      notification.error({ message: 'Произошла ошибка. Попробуйте еще раз' });
    }
  };

  const handleSave = async () => {
    // Файл уже загружен в Д и не было изменений -> ничего не делаем и закрываем модалку
    if (actFile?.urlLink) {
      setShowUploadActModal(false);
      return;
    }

    setLoading(true);
    const jsonDataClone = structuredClone(stepData);
    // Файла нет - сейвим пустой
    if (!actFile) {
      delete jsonDataClone.actFile;
      await handleUpdateActFile(jsonDataClone);
      return;
    }

    // Иначе загружаем файл, обновляем json, сохраняем новые данные
    const form = new FormData();
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    form.append('file', actFile.originFileObj);
    const uploadedFile = await uploadFile(form, headers);
    jsonDataClone.actFile = uploadedFile;

    await handleUpdateActFile(jsonDataClone);
    setLoading(false);
    onRefetchData();
  };

  useEffect(() => {
    setActFile(stepData.actFile || null);
  }, [stepData]);

  return (
    <>
      <Card
        style={{
          width: '100%', borderRadius: '15px', marginTop: '20px', height: '100%',
        }}
      >
        <Row justify="space-between" align="middle">
          <Col style={{ fontSize: '20px', color: '#212121' }}>Акт сдачи-приемки выполненных работ по этапу</Col>
          <Col>
            <Row gutter={10}>
              <Col>
                <Button type="primary" onClick={() => window.open('/coexecutors25/Акт по Договору НИР, НИОКР (2025).docx')} shape="round">
                  Шаблон акта
                </Button>
              </Col>
              {getUserRole() === 'bigAdmin' && (
              <Col>
                <Button type="primary" onClick={() => setShowUploadActModal(true)} shape="round">
                  Загрузить
                </Button>
              </Col>
              )}
              {actFile?.urlLink && (
              <Col>
                <Button type="primary" onClick={() => window.open(actFile.urlLink)} shape="round" style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
                  Скачать
                </Button>
              </Col>
              )}
            </Row>
          </Col>
        </Row>
      </Card>

      {showUploadModal && (
      <Modal
        visible
        width="70vw"
        maskClosable={false}
        onCancel={() => {
          setShowUploadActModal(false);
        }}
        title="Загрузка файла акта сдачи-приемки выполненных работ по этапу"
        footer={[
          <Button disabled={loading} key="submit" type="primary" onClick={handleSave}>
            {actFile?.urlLink ? 'Закрыть' : 'Сохранить'}
          </Button>,
        ]}
      >
        <Col>
          {!actFile && (
          <Dragger
            showUploadList={false}
            onChange={(e) => setActFile(e.file)}
            action={null}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Выберите или перенесите файл, чтобы загрузить (не более 15мб). Для прикрепления нескольких файлов осуществляйте их загрузку по очереди, а не одновременно</p>
          </Dragger>
          )}
          {actFile && (
          <Row style={{ margin: '5px 0px' }} gutter={12}>
            {actFile.urlLink && <Col><DownloadOutlined style={{ cursor: 'pointer' }} onClick={() => window.open(actFile.urlLink)} /></Col>}
            <Col><DeleteOutlined style={{ cursor: 'pointer' }} onClick={handleRemoveFile} /></Col>
            <Col>{actFile.name}</Col>
          </Row>
          )}
        </Col>
      </Modal>
      )}
    </>
  );
};

Act.propTypes = {
  stepId: PropTypes.string.isRequired,
  stepData: PropTypes.shape().isRequired,
  onRefetchData: PropTypes.func.isRequired,
};
